import React, { Fragment, useEffect, useState, forwardRef } from "react";
import { useAuth } from "../context/AuthContext";
import AsyncSelect from "react-select/async";

const DropDownUserRoleSelection = forwardRef(({
  defaultValue,
  onSelected,
  filtered = false,
  disabled = false,
  placeholderText = "Select Role",
}, ref) => {
  const { authAxios } = useAuth();
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (defaultValue === null || defaultValue === undefined) return;
    setSelected({ value: defaultValue, label: defaultValue });
  }, [defaultValue]);

  const fetchRoles = async () => {
    try {
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {
          filtered: filtered,
        },
      };

      const response = await authAxios().get(
        "/api/backoffice/users/roles",
        config,
      );
      
      // Map roles to react-select format
      const options = response.data.map(role => ({
        value: role,
        label: role
      }));
      
      return options;
    } catch (error) {
      console.log("Error fetching user roles");
      console.log(error);
      console.log(error.stack);
    }
    return [];
  };

  const selectRole = (roleOption) => {
    setSelected(roleOption);
    onSelected(roleOption?.value);
  };

  const promiseOptions = () =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(fetchRoles());
      }, 300);
    });

  // Expose methods to the parent component via ref
  React.useImperativeHandle(ref, () => ({
    reset: () => {
      setSelected(null);
      onSelected(null);
    }
  }));

  return (
    <Fragment>
      <AsyncSelect
        className={"fs-input"}
        cacheOptions
        loadOptions={promiseOptions}
        defaultOptions={true}
        isClearable={true}
        onChange={(data) => {
          selectRole(data);
        }}
        value={selected}
        placeholder={placeholderText}
        isDisabled={disabled}
      />
    </Fragment>
  );
});

export default DropDownUserRoleSelection;
